import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class WarehouseRestockPersonRequest {
  @jsonMember(String)
  public readonly dignity?: Nillable<string>;

  @jsonMember(String)
  public readonly email?: Nillable<string>;

  @jsonMember(String)
  public readonly phone?: Nillable<string>;

  public constructor(data: {
    dignity?: Nillable<string>;
    email?: Nillable<string>;
    phone?: Nillable<string>;
  }) {
    this.dignity = data.dignity;
    this.email = data.email;
    this.phone = data.phone;
  }
}
